import {Layers, WalkOfShameLayers} from "./WalkOfShameLayers";
import {WalkOfShame} from "../WalkOfShame";
import {WalkOfShameGameMode} from "../server/WalkOfShameGameMode";

export class WalkOfShameReelBackground extends PIXI.Container {
    private _reelBg: PIXI.Sprite;
    private _reelFrame: PIXI.Sprite;
    private _mainReelFrameTexture: PIXI.Texture;
    private _fsReelFrameTexture: PIXI.Texture;
    private _sfsReelFrameTexture: PIXI.Texture;

    constructor() {
        super();

        WalkOfShameLayers.getLayer(Layers.REEL_BACKGROUND)?.addChild(this);
        this.init();
    }

    public onModeChange(mode: string): void {
        this._reelFrame.y = 386;

        if (mode === WalkOfShameGameMode.NORMAL || mode === WalkOfShameGameMode.RESPIN) {
            this._reelFrame.texture = this._mainReelFrameTexture;
        } else if (mode === WalkOfShameGameMode.FREESPIN) {
            this._reelFrame.texture = this._fsReelFrameTexture;
        } else {
            this._reelFrame.texture = this._sfsReelFrameTexture;
            this._reelFrame.y = 351;
        }
    }

    private init(): void {
        const reelFrameTextureName: string = "realframe/reelFrame";

        this._mainReelFrameTexture = WalkOfShame.assetLoader.getTextures(reelFrameTextureName)[0];
        this._fsReelFrameTexture = WalkOfShame.assetLoader.getTextures(reelFrameTextureName + "_FS")[0];
        this._sfsReelFrameTexture = WalkOfShame.assetLoader.getTextures(reelFrameTextureName + "_SFS")[0];

        this._reelBg = new PIXI.Sprite(WalkOfShame.assetLoader.getTextures("realframe/reelFrame_background")[0]);
        this._reelBg.anchor.set(0.5);
        this._reelBg.position.set(360, 386);

        this._reelFrame = new PIXI.Sprite();
        this._reelFrame.anchor.set(0.5);
        this._reelFrame.x = 360;

        this.addChild(this._reelBg, this._reelFrame);
    }
}